module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/reportdashboard/reportattachments/reportattachments.component.css
// module id = ./src/app/reportdashboard/reportattachments/reportattachments.component.css
// module chunks = main